import React from 'react'
import Spinner from '../../components/Spinner/Spinner'
import { useAuthentication } from '../../context/authenticationContext'

import Dashboard from '../Dashboard/Dashboard'

const Home = () => {
  const { isLoading, userName } = useAuthentication()

  return (
    <section>
      {isLoading ? <Spinner /> : <Dashboard userName={userName} />}
    </section>
  )
}

export default Home
